import type { PropsWithChildren } from 'react';

import { DynamicTooltipRenderer } from './components/DynamicTooltipRenderer.js';
import { Action } from './components/global-actions/Action.js';
import { ActionsPlaceholder } from './components/global-actions/ActionsPlaceholder.js';
import { Header } from './components/header/Header.js';
import { Series } from './components/series/Series.js';
import { SeriesHeader } from './components/series/SeriesHeader.js';
import { SeriesItem } from './components/series/SeriesItem.js';
import { TooltipPortal } from './components/TooltipPortal.js';
import type { OverlayTooltipProps } from './types.js';

/**
 * Tooltip root component
 * @internal
 */
const TooltipRoot = (props: PropsWithChildren<OverlayTooltipProps>) => {
  if (props.absoluteX !== undefined && props.absoluteY !== undefined) {
    return (
      <TooltipPortal
        isInteractive={props.isInteractive ?? false}
        absoluteX={props.absoluteX}
        absoluteY={props.absoluteY}
      >
        {props.children}
      </TooltipPortal>
    );
  }

  return <DynamicTooltipRenderer {...props} />;
};

/**
 * OverlayTooltip WIP component
 * @internal
 */
export const OverlayTooltip = Object.assign(TooltipRoot, {
  Action,
  ActionsPlaceholder,
  Header,
  Series,
  SeriesHeader,
  SeriesItem,
});

export const Tooltip = () => null;
Tooltip.displayName = 'ChartTooltip';
/**
 * ChartTooltip Component
 * @public
 */
export const ChartTooltip = Object.assign(Tooltip, {
  Action,
  ActionsPlaceholder,
  Series,
  SeriesHeader,
  SeriesItem,
});
